import { render, staticRenderFns } from "./EditClassList.vue?vue&type=template&id=2912d658&scoped=true&"
import script from "./EditClassList.vue?vue&type=script&lang=js&"
export * from "./EditClassList.vue?vue&type=script&lang=js&"
import style0 from "./EditClassList.vue?vue&type=style&index=0&id=2912d658&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2912d658",
  null
  
)

export default component.exports